// Core
import { useCallback, useMemo, useState, useRef, useEffect } from 'react';
import { 
  Box,
  Button,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Input,
  Select,
  Grid,
  Text,
  useColorMode,
  useDisclosure,
  useColorModeValue
} from '@chakra-ui/react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

// Assets
import logo from 'assets/img/logo.png';
import signUpFinishedC from 'assets/img/sign-up-finished-c.png';
import signUpFinishedH from 'assets/img/sign-up-finished-h.png';
import { apiService } from 'services/ApiService';

// Components
import ErrorCard from 'components/Form/Errors';

const SignUpFinish = ({ 
  newObject, 
  isOpen, 
  onOpen, 
  isDark,
  topLine
}) => {
  const textColor = useColorModeValue('#0E1633', 'white');
  const textTimerColor = useColorModeValue('#0E1633', '#9FABCB');

  const history = useHistory();
  const goToSignIn = () => {          
      history.push('/auth/login'); 
  };

  /*const [errorCard, setErrorCard] = useState();

  const resendEmail = async () => {
  	try {
      const response = await apiService.registrationResendEmail({
        email: newObject.email 
      });

      if (response.data === false || response.statusCode !== 200) {
        setErrorCard(response.message);
      } else {
        startTimer(); // stop
        startTimer(); // start
      }
    } catch (error) {
      setErrorCard(true);
      console.error('Error:', error);
    } 
  };

  const [seconds, setSeconds] = useState(59);
  const [timerActive, setTimerActive] = useState(true);

  useEffect(() => {
      let interval = null;
      
      if (timerActive && seconds > 0) {
        interval = setInterval(() => {
          setSeconds(seconds => seconds - 1);
        }, 1000);
      } else if (!timerActive && seconds !== 0) {
        clearInterval(interval);
      } else if (seconds === 0) {
        setTimerActive(false);
      }

      return () => clearInterval(interval);
  }, [timerActive, seconds]);

  const startTimer = () => {
      setTimerActive(true);
      setSeconds(59);  
  };*/

  return (
  	<Modal isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent 
      	className="modal__simple modal__simple_full-screen" 
        style={{borderRadius: '0 !important', textAlign: 'center'}}>
        <ModalBody>
          <Box mt="80px" mb={{base: '50px', sm: '60px', md: '79px'}} display="flex" alignItems="center" justifyContent="center">
	        <Image src={logo} alt='lmctplus image' maxWidth="184px"/>
	      </Box>

	      <Box position="relative">
	        <Flex gap="8px" justifyContent="center" alignItems="center">
	        	<Text as="h1" variant="header-gradient" fontSize={{base: '32px', sm: '40px', md: '48px'}}>Welcome to LMCT+!</Text>
	        	<Text as="span" fontSize={{base: '32px', sm: '40px', md: '48px'}}>🎉</Text>
	      	</Flex>
	        <Box bg={topLine} left="50%" transform="translateX(-50%) rotate(0deg)" bottom="-2px" h="1px" position="absolute" w="50%" />
	      </Box>

	      <Text fontSize={{base: '16px', md: '20px'}} maxW="500px" m="0 auto" color={textColor} mt="14px">
	      	Your account is ready to go. Sign in to start enjoying all the benefits available to LMCT+ members.
	  	  </Text>

	  	  <Box position="relative" w="300px" h="300px" m="90px auto 60px auto">
	  	  	{ isDark && <Box bg="rgba(64, 155, 255, 0.82)" zIndex="-1" position="absolute" opacity="0.6" filter="blur(70px)" h="300px" w="300px" borderRadius="full" /> }

	  	  	<Image src={signUpFinishedC} position="absolute" alt='lmctplus image' maxWidth="184px" zIndex="2"/>
	  	  	<Image src={signUpFinishedH} position="absolute" right="0" alt='lmctplus image' maxWidth="184px" zIndex="1" mt="90px"/>
	  	  </Box>

        { /*!errorCard &&
          <>
  	  	  <Text fontSize={{base: '16px', md: '20px'}} maxW="500px" m="0 auto" color={textColor}>
  	      	Didn`t receive the email yet?
  	      </Text>
  	      <Flex justify="center" mt="12px" gap="8px">
  	      	<Text color={textTimerColor} className={!timerActive ? 'hidden' : ''}>
  	          	Wait for 
  	          	<Text as="span" pl="4px" color={textTimerColor}>
  	            	{Math.floor(seconds / 60)}:{seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60}
  	            </Text>
  	        </Text>
  	        <Text 
  	        	color={ timerActive ? textColor : '#099BFF'}
  	        	variant="title-md" 
  	        	cursor="pointer"
  	        	pointerEvents={ timerActive ? 'none' : 'unset'}
  	        	onClick={resendEmail}>
  	        	Send Again
  	        </Text>
  	      </Flex>
          </>
        }

        { errorCard &&
          <Box maxW={{base: '100%', md: '50%'}} m="16px auto" >
            <ErrorCard error={errorCard} mt="16px" mb="16px"/>
          </Box>
        */}

        <Button variant="button-md" mt="12px" w={{base: '100%', md: '168px'}} onClick={goToSignIn}>Sign In</Button>

	      <Box h="80px" />

        </ModalBody>
      </ModalContent>
    </Modal> 
  );
};

export default SignUpFinish;